/*
  Gothic FAQ — smooth accordion + live search filter.
*/
(function () {
  function initFaq(faq) {
    // Accordion toggle (smooth height animation via max-height)
    faq.querySelectorAll('.faq-item__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item');
        var panel = item.querySelector('.faq-item__a');
        var isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : null;
      });
    });

    // Keep open panels sized correctly on resize
    window.addEventListener('resize', function () {
      faq.querySelectorAll('.faq-item.is-open .faq-item__a').forEach(function (p) {
        p.style.maxHeight = p.scrollHeight + 'px';
      });
    });

    // Live search filter
    var search = faq.querySelector('[data-faq-search]');
    if (!search) return;
    var noResults = faq.querySelector('[data-faq-noresults]');

    search.addEventListener('input', function () {
      var q = search.value.trim().toLowerCase();
      var visibleCount = 0;

      faq.querySelectorAll('.faq-item').forEach(function (item) {
        var match = !q || item.textContent.toLowerCase().indexOf(q) !== -1;
        item.style.display = match ? '' : 'none';
        if (match) visibleCount++;
      });

      // Hide category headers whose questions are all filtered out
      faq.querySelectorAll('.faq-category').forEach(function (cat) {
        var anyVisible = false;
        var el = cat.nextElementSibling;
        while (el && !el.classList.contains('faq-category')) {
          if (el.classList.contains('faq-item') && el.style.display !== 'none') {
            anyVisible = true;
            break;
          }
          el = el.nextElementSibling;
        }
        cat.style.display = anyVisible ? '' : 'none';
      });

      if (noResults) noResults.style.display = visibleCount ? 'none' : '';
    });
  }

  function boot() {
    document.querySelectorAll('.gothic-faq').forEach(initFaq);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
